import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { GET_GOLF_INVENTORY_TYPE, GET_GOLF_INVENTORY_TYPE_ERROR, GET_GOLF_INVENTORY_TYPE_SUCCESS } from '../../../../actions.js';

function* getGolfInventoryType({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/golf-inventory/configuration`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: {
        ...payload?.params,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_GOLF_INVENTORY_TYPE_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_GOLF_INVENTORY_TYPE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_GOLF_INVENTORY_TYPE_ERROR, payload: error });
  }
}

export function* watchgetGolfInventoryType() {
  yield takeEvery(GET_GOLF_INVENTORY_TYPE, getGolfInventoryType);
}

function* getGolfInventoryTypeSaga() {
  yield all([fork(watchgetGolfInventoryType)]);
}

export default getGolfInventoryTypeSaga;
